function HeroTile() {
  return (
    <section className="bentolio-card bentolio-area-hero">
      <img
        src="/images/pbj-logo.png"
        alt="Peanut Butter & Jelly Event Decor"
        className="hero-logo"
      />
      <h1 className="display-text">
        Making Every Celebration Feel Like A Dream Come True
      </h1>
    </section>
  );
}

export default HeroTile;
